import { useState } from 'react'

// Editable state that starts at `source` and resets whenever `source` changes.
//
// Use it instead of `useState(x)` + `useEffect(() => setX(x), [x])`. That effect
// runs after the first render, and on a busy machine it can run after the user
// (or a test) has already typed: it then overwrites the edit with the loaded
// value. This syncs during render instead (React's "adjusting state when a prop
// changes" pattern), so there is no late write to race with.
// Test: hooks/__tests__/useSyncedState.test.jsx reproduces the race.
export function useSyncedState(source) {
  const [value, setValue] = useState(source)
  const [syncedFrom, setSyncedFrom] = useState(source)
  if (!Object.is(source, syncedFrom)) {
    setSyncedFrom(source)
    setValue(source)
  }
  return [value, setValue]
}
